import moment from "moment";
import ServiceApiName from "./ServiceApiName";
import ServiceRegExr from "./RegExr";
import { serviceFeatureMap } from "./serviceFeatureMap";

const setauthToken = async (token) => {
  try {
    localStorage.setItem("authToken", token);
    return true;
  } catch (error) {
    console.error(error);
    return false;
  }
};

const GetAuthHeader = () => {
  try {
    let Remember = localStorage.getItem("authToken");
    return Remember ? { token: Remember } : "";
  } catch (error) {
    console.log("try catch[ service> GetLogintoken] error:", error.message);
  }
};
const getAuthToken = async () => {
  try {
    return localStorage.getItem("authToken");
  } catch (error) {
    console.error(error);
    return null;
  }
};
const setCredit = async (credit) => {
  try {
    return localStorage.setItem("credit", credit);
  } catch (error) {
    console.error(error);
    return null;
  }
};
const getCredit = () => {
  try {
    return localStorage.getItem("credit");
  } catch (error) {
    console.error(error);
    return null;
  }
};
const setUserdata = (userdata) => {
  try {
    return localStorage.setItem("userdata", JSON.stringify(userdata));
  } catch (error) {
    console.error(error);
    return null;
  }
};

const getAuthTokenAndHeader = () => {
  const token = localStorage.getItem("authToken");
  const username = JSON.parse(localStorage.getItem("userdata"));
  return {
    token: token,
    username: username?.email,
  };
};
const getAuthUser = () => {
  const username = JSON.parse(localStorage.getItem("userdata"));
  return {
    username: username?.email,
  };
};
const getUserdata = () => {
  try {
    // return JSON.parse(localStorage.getItem("userdata"));
    const data = JSON.parse(localStorage.getItem("userdata"));
    const packages = {};
    for (const key in data.packages) {
      packages[key] = true;
    }
    const res = {
      ...data,
      // email: "test3.gmail.com",
      is_corporate_admin: true,
      packages: {
        ...packages,
      },
    };

    return data;
  } catch (error) {
    console.error(error);
    return null;
  }
};
const setIsLoginData = async (data) => {
  try {
    localStorage.setItem("IsLoginData", JSON.stringify(data));
    return true;
  } catch (error) {
    console.error(error);
    return false;
  }
};
const getIsLoginData = () => {
  try {
    return JSON.parse(localStorage.getItem("IsLoginData"));
  } catch (error) {
    console.error(error);
    return null;
  }
};
const logout = async (navigate) => {
  try {
    navigate("/auth/sign-in");
    return localStorage.clear();
  } catch (error) {
    console.error(error);
    return null;
  }
};

// const walletBalanceFunction = (
//   produtcApi,
//   dispatch,
//   Ewallet,
//   value,
//   MoreValue
// ) => {
//   const features = Service.getUserdata()?.packages || {};

//   if (MoreValue) {
//     dispatch(
//       Ewallet({
//         description: `${produtcApi} - ${MoreValue?.panNumber || MoreValue.mobileNumber
//           }`,
//         productName: produtcApi,
//         value: MoreValue?.panNumber || MoreValue.mobileNumber,
//         MoreValue: MoreValue,
//       })
//     );
//   } else {
//     dispatch(
//       Ewallet({
//         description: `${produtcApi} - ${value}`,
//         productName: produtcApi,
//         value: value,
//       })
//     );
//   }
// };

const walletBalanceFunction = (productApi, dispatch, Ewallet, value, MoreValue, v) => {
  const { packages: features = {}, user_packages_info } = getUserdata() || {};
  const descriptionValue = MoreValue?.panNumber || MoreValue?.mobileNumber || value;

  const apiFeatureMap = {}
  apiFeatureMap[ServiceApiName["Gstsearch"]] = features["GST"];
  apiFeatureMap[ServiceApiName["GstRefresh"]] = features["GST"];
  apiFeatureMap[ServiceApiName["Cinsearch"]] = features["CIN"];
  apiFeatureMap[ServiceApiName["CinRefresh"]] = features["CIN"];
  apiFeatureMap[ServiceApiName["Dinsearch"]] = features["DIN"];
  apiFeatureMap[ServiceApiName["DinMoblieEmail"]] = features["DIN"];
  apiFeatureMap[ServiceApiName["Iecsearch"]] = features["IEC"];
  apiFeatureMap[ServiceApiName["Msmesearch"]] = features["MSME"];
  apiFeatureMap[ServiceApiName["MsmeRefresh"]] = features["MSME"];
  apiFeatureMap[ServiceApiName["Pansearch"]] = features["PAN"];
  apiFeatureMap[ServiceApiName["BusinessPansearch"]] = features["PAN"];
  apiFeatureMap[ServiceApiName["PanRefresh"]] = features["PAN"];
  apiFeatureMap[ServiceApiName["Madsearch"]] = features["MAD"];
  apiFeatureMap[ServiceApiName["Mobile360search"]] = features["Mobile360"];
  apiFeatureMap[ServiceApiName["MultipleUPI"]] = features["Mobile360"];
  apiFeatureMap[ServiceApiName["InfoByPhonesearch"]] = features["OSINT"];
  apiFeatureMap[ServiceApiName["InfoMoreByPhonesearch"]] = features["OSINT"];
  apiFeatureMap[ServiceApiName["InfoByEmailsearch"]] = features["OSINT"];
  apiFeatureMap[ServiceApiName["InfoMoreByEmailsearch"]] = features["OSINT"];
  apiFeatureMap[ServiceApiName["Darpansearch"]] = features["DARPAN"];
  apiFeatureMap[ServiceApiName["Mcasearch"]] = features["MCA"];
  apiFeatureMap[ServiceApiName["Pdfsearch"]] = true;

  const featuresKey = Object.fromEntries(
    Object.entries(user_packages_info).map(([id, name]) => [name, id])
  );
  let searchNameID = {};
  Object.entries(serviceFeatureMap).forEach(([serviceKey, featureName]) => {
    if (ServiceApiName[serviceKey] && featuresKey[featureName]) {
      searchNameID[ServiceApiName[serviceKey]] = featuresKey[featureName];
    }
  });
  let payload = {
    description: `${productApi} - ${descriptionValue}`,
    productName: productApi,
    value: descriptionValue,
    apiFeature: apiFeatureMap[productApi],
    productId: searchNameID?.[productApi]

  };

  if (v) {
    payload.change_value = v
  }

  if (MoreValue) {
    payload.MoreValue = MoreValue;
  }
  dispatch(Ewallet(payload));
};
const PanType = (number) => {
  if (typeof number !== "string" || number.length < 4) {
    return "";
  }
  const numer2 = number.toLowerCase()[3];
  switch (numer2) {
    case "c":
      return "Company";
    case "p":
      return "Person";
    case "h":
      return "HUF (Hindu Undivided Family)";
    case "f":
      return "Firm";
    case "a":
      return "AOP (Association of Persons)";
    case "t":
      return "Trust";
    case "b":
      return "Body of Individual";
    case "l":
      return "Local Authority";
    case "j":
      return "Artificial Judicial Person";
    case "g":
      return "Government";
    default:
      return "";
  }
};

const AddRecentSearch = (Searchdata, Routedata, number = 3) => {
  try {
    const existingSearches = localStorage.getItem(Routedata);
    let searches = existingSearches ? JSON.parse(existingSearches) : [];
    let isnumber = searches?.some((i) => i == Searchdata);
    if (!isnumber) {
      searches.unshift(Searchdata);
      if (searches.length > number) {
        searches.pop();
      }
    }
    localStorage.setItem(Routedata, JSON.stringify(searches));
  } catch (error) {
    console.error("Error updating recent search:", error);
  }
};
const GetRecentSearches = (Routedata) => {
  try {
    const searches = localStorage.getItem(Routedata);
    return searches ? JSON.parse(searches) : [];
  } catch (error) {
    console.error("Error retrieving recent searches:", error);
    return [];
  }
};
const lastDayesYYYMMDD = (number) => {
  return [...Array(number)]
    .map((_, index) =>
      moment()
        .clone()
        .subtract(1 + index, "days")
        .format("YYYY-MM-DD")
    )
    .reverse(); //1999-01-21
};
const lastDayesDDYY = (number) => {
  return [...Array(number)]
    .map((_, index) =>
      moment()
        .clone()
        .subtract(1 + index, "days")
        .format("DD-MM")
    )
    .reverse(); //21-01
};
const toCapitalize = (str) => {
  if (str) {
    return str
      ?.split(" ")
      .map((word) => word.charAt(0).toUpperCase() + word.slice(1).toLowerCase())
      .join(" ");
  } else {
    return str;
  }
};
const toUpperCase = (str) => {
  if (str) {
    return str
      ?.split(" ")
      .map((word) => word.charAt(0).toUpperCase() + word.slice(1).toUpperCase())
      .join(" ");
  } else {
    return str;
  }
};

const CruntDayTOBackDay = (day) => {
  const today = new Date();
  const startDate = new Date(today);
  startDate.setDate(today.getDate() - day);
  const endDate = new Date(today);
  endDate.setDate(today.getDate());
  const startDateFormatted = startDate.toString();
  const endDateFormatted = endDate.toString();
  return {
    startDateFormatted: moment(startDateFormatted).format("YYYY, M, DD"),
    endDateFormatted: moment(endDateFormatted).format("YYYY, M, DD"),
  };
};

const numberFormat = (data) => {
  return new Intl.NumberFormat("en-IN", {
    style: "decimal",
    minimumFractionDigits: 2,
    maximumFractionDigits: 2,
  }).format(data);
};

const dateFormating = (date) => {
  if (!date) return "";
  return moment(date, "MM/DD/YYYY HH:mm:ss").format("DD/MM/YYYY");
};
const formatNumber = (num, classprecision = 1, className) => {
  // If the number is less than 1000, return it as it is
  if (num < 1000) return num;

  // Indian Numbering System
  if (num >= 1000 && num < 100000) {
    // Thousands
    // return <span>{(num / 1000).toFixed(classprecision)}<span className={`${className}`}>K</span></span>;
    return (num / 1000).toFixed(classprecision) + "K";
  } else if (num >= 100000 && num < 10000000) {
    // Lakhs
    // return <span>{(num / 100000).toFixed(classprecision)}<span className={`${className}`}>L</span></span>
    return (num / 100000).toFixed(classprecision) + "L";
  } else if (num >= 10000000 && num < 100000000) {
    // Millions
    // return <span>{(num / 1000000).toFixed(classprecision)}<span className={`${className}`}>M</span></span>;
    return (num / 1000000).toFixed(classprecision) + "M";
  } else if (num >= 100000000) {
    // Crores
    // return <span>{(num / 10000000).toFixed(classprecision)}<span className={`${className}`}>Cr</span></span>;
    return (num / 10000000).toFixed(classprecision) + "Cr";
  }
};

const calculateAge = (birthdate, info, CuruntDay) => {
  if (birthdate) {
    const birthDate = moment(birthdate, "DD/MM/YYYY"); // Parse the input in DD/MM/YYYY format
    const today = moment();

    const years = today.diff(birthDate, "years"); // Get full years
    birthDate.add(years, "years"); // Adjust birthDate to the current date in terms of full years

    const months = today.diff(birthDate, "months"); // Get full months after the years
    birthDate.add(months, "months"); // Adjust birthDate to the current date in terms of full months

    const days = today.diff(birthDate, "days"); // Get remaining days after months
    if ("all" === info) {
      return `${years} years, ${months} months, ${days} days`; // Return age in years, months, and days
    } else if ("month" === info) {
      return `${months} month`; // Return age in months, and days
    } else if ("day" === info) {
      return `${days} days`; // Return age in days
    } else if ("yearsMonth" === info) {
      return `${years} years, ${months} months`; // Return age in years, months
    } else if ("monthDay" === info) {
      return `${months} months, ${days} days`; // Return age in months, and days
    } else if ("yearsDay" === info) {
      return `${years} years, ${days} days`; // Return age in years, and days
    } else if ("years" === info) {
      return `${years} years`; // Return age in years
    } else {
      return;
    }
  }
};
const CurontData = (str) => {
  const date = new Date();
  const dateformat = moment(date).format(`${str}`);
  return dateformat;
};
const dateFormatingyymmdd = (date) => {
  if (!date) return "";
  return moment(date, "YYYY/MM/DDTHH:mm:ss").format("DD/MM/YYYY");
};
const scroll0 = () => {
  window.scroll({
    top: 0,
    behavior: "smooth", // Enables smooth scrolling
  });
};

const PrasonAndBusinessUPICheck = (str) => {
  const valueBeforeAt = str.split("@")[0];
  const isOnlyNumbers = /^[0-9]+$/.test(valueBeforeAt);
  if (isOnlyNumbers) {
    return true;
  } else {
    return false;
  }
};

const hexToRgb = (hex, opacity = 1) => {
  hex = hex.replace(/^#/, "");

  if (hex.length === 3) {
    hex = hex
      .split("")
      .map(function (char) {
        return char + char;
      })
      .join("");
  }
  var r = parseInt(hex.substring(0, 2), 16);
  var g = parseInt(hex.substring(2, 4), 16);
  var b = parseInt(hex.substring(4, 6), 16);

  return `rgb(${r}, ${g}, ${b},${opacity})`;
};

const maskNumber = (number, maskChar = "*", revealCount = 3) => {
  if (number) {
    const numberStr = number.toString();
    const maskLength = numberStr.length - revealCount;
    if (maskLength <= 0) {
      return numberStr;
    }

    return maskChar.repeat(maskLength) + numberStr.slice(-revealCount);
  }
  return "";
};

const maskEmailAdvanced = (
  email,
  showUsernameChars = 3,
  showDomainChars = 3
) => {
  if (email) {
    const [username, domain] = email?.split("@");
    const maskedUsername = username?.slice(0, showUsernameChars) + "***";
    const domainParts = domain?.split(".");
    const maskedDomain =
      domainParts?.[0].slice(0, showDomainChars) + "***." + domainParts?.[1];
    return maskedUsername + "@" + maskedDomain;
  }
};

const DateFormet = (date, format = "DD-MM-YYYY hh:mm A") => {
  if (!date) return "";
  return moment(date, "MM/DD/YYYY HH:mm:ss").format(format);
};


const getValidationRule = (type) => {
  switch (type) {
    case "PAN":
      return {
        value: ServiceRegExr.panRegExr,
        message: "Invalid PAN Number"
      };
    case "GST":
      return {
        value: ServiceRegExr.gstRegExr,
        message: "Invalid GST Number"
      };
    case "CIN":
      return {
        value: new RegExp(
          `${ServiceRegExr.cinRegExr.source}|${ServiceRegExr.cinRegExrllp.source}|${ServiceRegExr.cinRegExrf.source}`
        ), message: "Invalid CIN Number"
      };
    case "DIN":
      return {
        value: ServiceRegExr.dinRegExr,
        message: "Invalid DIN Number"
      };
    case "MSME":
      return {
        value: ServiceRegExr.msmeRegExr,
        message: "Invalid MSME Number"
      };
    case "IEC":
      return {
        value: ServiceRegExr.iecRegExr,
        message: "Invalid IEC Number"
      };
    case "MOBILE":
      return {
        value: ServiceRegExr.mobile360RegExr,
        message: "Invalid Mobile Number"
      };
    case "EMAIL":
      return {
        value: ServiceRegExr.emailRegExr,
        message: "Invalid Email Number"
      };
    default:
      return undefined;
  }
};
const apiMap = {
  PAN: ServiceApiName.Pansearch,
  GST: ServiceApiName.Gstsearch,
  CIN: ServiceApiName.Cinsearch,
  DIN: ServiceApiName.Dinsearch,
  MSME: ServiceApiName.Msmesearch,
  IEC: ServiceApiName.Iecsearch,
};
const unique = (arr) => [...new Set(arr)];

const CountByLastDaysData = (GSTByLastDaysData, name, subname) => {
  const now = new Date();
  const currentMonth = now.getMonth() + 1; // 1-based
  const currentYear = now.getFullYear();

  const pad = (n) => n.toString().padStart(2, '0');

  const thisMonthPrefix = `${currentYear}-${pad(currentMonth)}`;

  let lastMonthDate = new Date(currentYear, currentMonth - 2, 1); // month is 0-based
  const lastMonthPrefix = `${lastMonthDate.getFullYear()}-${pad(lastMonthDate.getMonth() + 1)}`;

  const thisMonthTotal = GSTByLastDaysData
    .filter(item => item?.[subname]?.startsWith(thisMonthPrefix))
    .reduce((sum, item) => sum + item[name], 0);

  const lastMonthTotal = GSTByLastDaysData
    .filter(item => item?.[subname]?.startsWith(lastMonthPrefix))
    .reduce((sum, item) => sum + item[name], 0);

  const percent = lastMonthTotal === 0 ? 0 : ((thisMonthTotal / lastMonthTotal) * 100).toFixed(0);

  return {
    thisMonthTotal,
    lastMonthTotal,
    percent,
  };
};

function capitalizeFirstLetter(str) {
  if (typeof str !== 'string' || str.length === 0) {
    return str; // Handle non-string input or empty strings
  }
  return str.charAt(0).toUpperCase() + str.slice(1).toLowerCase();
}

const infoDataHead = (header) => {
  const username = JSON.parse(localStorage.getItem("userdata"));
  const location = JSON.parse(localStorage.getItem("location"));
  return {
    "ClientId": "84fd2189afae0d53e7025a35ec76b70cfb0a48d67ec72f3b78f2a2ce5f9297f2",
    "SecreteKey": "c1cf43a7c4d7f9984d3cf703083732ae6b54ef772a3f3f5d9b4f0dc0f302e263",
    "UserName": username?.email,
    "Latitude": location?.latitude || "23.0621113114",
    "Longitude": location?.longitude || "72.5559636",
    ...header
  };
};
const setlocation = async (data) => {
  if (!data.latitude || !data.longitude) return false;
  try {
    localStorage.setItem("location", JSON.stringify(data));
    return true;
  } catch (error) {
    console.error(error);
    return false;
  }
};
const Service = {
  setauthToken,
  setIsLoginData,
  getIsLoginData,
  getAuthToken,
  getCredit,
  setCredit,
  getUserdata,
  setUserdata,
  logout,
  walletBalanceFunction,
  GetAuthHeader,
  AddRecentSearch,
  GetRecentSearches,
  lastDayesDDYY,
  lastDayesYYYMMDD,
  toCapitalize,
  toUpperCase,
  CruntDayTOBackDay,
  numberFormat,
  dateFormating,
  formatNumber,
  calculateAge,
  CurontData,
  dateFormatingyymmdd,
  scroll0,
  PanType,
  PrasonAndBusinessUPICheck,
  hexToRgb,
  maskEmailAdvanced,
  maskNumber,
  DateFormet,
  getAuthTokenAndHeader,
  getAuthUser,
  getValidationRule,
  apiMap,
  unique,
  CountByLastDaysData,
  capitalizeFirstLetter,
  infoDataHead,
  setlocation,
};
export default Service;
